import React, { useState, useMemo } from "react";
import Tooltip from "@mui/material/Tooltip";
// import DetailsPanel from "./Viewkpi/components/DetailPanel";
import Dialog from "@mui/material/Dialog";
import { DetailsPanelFile } from "./Viewkpi/components/DetailsPanelFile";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import { ArrowUp, ArrowDown } from "lucide-react";



export default function KpiDiscovery({ tableData = [], totalCount = 0, onSortChange, sortConfig = { key: null, order: null }  // ADD THIS
}) {
  const BASE_URL = process.env.REACT_APP_API_URL;

  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [openViewModal, setOpenViewModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  // Column-wise search state
  const [columnSearch, setColumnSearch] = useState({
    product_name: "",
    kpi_name: "",
    definition: "",
    granitutity: "",
  });


  // Handle column search change
  const handleColumnSearch = (key, value) => {
    setColumnSearch((prev) => ({
      ...prev,
      [key]: value,
    }));
    setPage(1); // reset to first page on search
  };

  const handleViewClick = async (row) => {
    try {
      const response = await fetch(
        `${BASE_URL}/kpi/view/${row.product_name}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sections: [],
            kpiName: row.kpi_name,
            kpiType: [],
          }),
        }
      );

      const data = await response.json();
      setSelectedRow(data.data);
      setOpenViewModal(true);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSort = (columnKey) => {
    let newOrder;

    if (sortConfig.key !== columnKey) {
      newOrder = 'asc';
    } else if (sortConfig.order === 'asc') {
      newOrder = 'desc';
    } else if (sortConfig.order === 'desc') {
      newOrder = null;
    } else {
      newOrder = 'asc';
    }

    // Just call parent - don't manage state here
    if (onSortChange) {
      onSortChange(columnKey, newOrder);
    }

    setPage(1);
  };


  const filteredData = useMemo(() => {
    return tableData.filter((row) =>
      Object.entries(columnSearch).every(([key, value]) => {
        if (!value) return true;
        return (
          row[key]?.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
  }, [tableData, columnSearch]);

  // Pagination - handle 0 case properly
  const totalPages = Math.max(1, Math.ceil(filteredData.length / pageSize));
  const hasData = filteredData.length > 0;

  const getPages = () => {
    if (!hasData) return [];

    const pages = [];
    const max = 5;

    if (totalPages <= max) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    if (page <= 3) return [1, 2, 3, 4, 5];

    if (page >= totalPages - 2) {
      return [
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    return [page - 2, page - 1, page, page + 1, page + 2];
  };

  const visibleData = hasData
    ? filteredData.slice((page - 1) * pageSize, page * pageSize)
    : [];
  const firstValue = selectedRow
    ? Object.values(selectedRow)[0]
    : null;

  return (
    <div className="poppins-regular">
      <div className="flex justify-between items-center mb-4">
        <span className="bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-md shadow-sm">
          THERE ARE {filteredData.length} UNIQUE KPI  FOUND
        </span>

        {/* Only show pagination if there's data */}
        {hasData && (
          <div className="flex items-center gap-1 text-sm">
            <button
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
              className="px-3 py-1 border rounded disabled:opacity-40"
            >
              Prev
            </button>

            {page > 3 && totalPages > 5 && (
              <>
                <button onClick={() => setPage(1)} className="px-3 py-1 border rounded">
                  1
                </button>
                <span>…</span>
              </>
            )}

            {getPages().map((p) => (
              <button
                key={p}
                onClick={() => setPage(p)}
                className={`px-3 py-1 border rounded ${page === p ? "bg-[#bb1ccc] text-white" : ""
                  }`}
              >
                {p}
              </button>
            ))}

            {page < totalPages - 2 && totalPages > 5 && (
              <>
                <span>…</span>
                <button
                  onClick={() => setPage(totalPages)}
                  className="px-3 py-1 border rounded"
                >
                  {totalPages}
                </button>
              </>
            )}

            <button
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
              className="px-3 py-1 border rounded disabled:opacity-40"
            >
              Next
            </button>
          </div>
        )}
      </div>

      <div className="rounded-lg border border-gray-200">
        <table className="table-fixed border-collapse  w-full">
          <colgroup>
            <col style={{ width: '17%' }} />  {/* Report Name */}
            <col style={{ width: '18%' }} />  {/* KPI */}
            <col style={{ width: '40%' }} />  {/* Definition */}
            <col style={{ width: '13%' }} />  {/* Granularity */}
            <col style={{ width: '100px' }} />  {/* View */}
          </colgroup>
          <thead className="text-[#404040]  bg-[#6d6b9e1a]" >

            <tr>
              {[
                { label: "Report Name", key: "product_name" },
                { label: "KPI", key: "kpi_name" },
                { label: "Definition", key: "definition" },
                { label: "Granularity", key: "granitutity" }
              ].map(({ label, key }) => (
                <th key={label} className="px-4 pt-[10px] pb-[6px] text-[13px] font-normal">
                  <div className="flex items-center gap-[10px]">
                    <span>{label}</span>


                    <span className="ml-2 cursor-pointer" onClick={() => handleSort(key)}>
                      {sortConfig.key === key && sortConfig.order !== null ? (
                        sortConfig.order === 'asc' ? (
                          <ArrowUp size={16} style={{ color: '#bb1ccc' }} />
                        ) : (
                          <ArrowDown size={16} style={{ color: '#bb1ccc' }} />
                        )
                      ) : (
                        <ArrowUp size={16} style={{ color: '#9CA3AF' }} />
                      )}
                    </span>
                  </div>
                </th>
              ))}
              <th className="w-[60px]"></th>
            </tr>

            {/* Column Search Row */}
            <tr>
              <th className="px-4 pb-[10px]">
                <input
                  value={columnSearch.product_name}
                  onChange={(e) =>
                    handleColumnSearch("product_name", e.target.value)
                  }
                  placeholder="Search"
                  className="w-full text-[9px] pl-3 py-2 rounded "
                />
              </th>

              <th className="px-4 pb-[10px]">
                <input
                  value={columnSearch.kpi_name}
                  onChange={(e) =>
                    handleColumnSearch("kpi_name", e.target.value)
                  }
                  placeholder="Search"
                  className="w-full text-[9px] pl-3 py-2 rounded"
                />
              </th>

              <th className="px-4 pb-[10px]">
                <input
                  value={columnSearch.definition}
                  onChange={(e) =>
                    handleColumnSearch("definition", e.target.value)
                  }
                  placeholder="Search"
                  className="w-full text-[9px] pl-3 py-2 rounded"
                />
              </th>



              <th className="px-4 pb-[10px]">
                <input
                  value={columnSearch.granitutity}
                  onChange={(e) =>
                    handleColumnSearch("granitutity", e.target.value)
                  }
                  placeholder="Search"
                  className="w-full text-[9px] pl-3 py-2 rounded"
                />
              </th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {visibleData.map((row, idx) => (
              <tr
                key={idx}
                className={`${idx % 2 === 0 ? "bg-white" : "bg-[#F5F5F5]"
                  } hover:bg-[#E4F8F1]`}
              >
                <td className="px-4 py-3 text-[12px]">
                  {row.product_name || "NA"}
                </td>

                <td className="px-4 py-3 text-[12px] uppercase">
                  <span
                    className="inline-block px-3 py-1 bg-[#F6EBF2] text-[#CD0B7F] border rounded-full whitespace-normal">
                    {row.kpi_name || "NA"}
                  </span>
                </td>


                <td className="px-4 py-3 text-[12px] ">
                  <Tooltip title={row.definition || "NA"} arrow>
                    <span className="block truncate">
                      {row.definition || "NA"}
                    </span>
                  </Tooltip>
                </td>



                <td className="px-4 py-3 text-[12px]">
                  NA
                </td>

                <td className="text-center">

                  <button
                    onClick={() => handleViewClick(row)}
                    className="bg-blue-100 text-blue-600 px-3 py-1 rounded text-[10px]"
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}

            {visibleData.length === 0 && (
              <tr>
                <td colSpan="6" className="text-center py-6 text-gray-500">
                  No matching KPIs found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Dialog
        open={openViewModal}
        onClose={() => setOpenViewModal(false)}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            height: "90vh",
            borderRadius: "12px",
            // padding:'30px'
          },
        }}
      >
        {/* Header */}
        <div className="flex justify-between border-b mb-[13px] p-5">
          <div className="flex flex-col  px-2 py-4 ">
            <h3 className="text-lg font-semibold mb-2 text-gray-900">
              {firstValue?.title}
            </h3>
            <p className="text-sm leading-relaxed text-gray-600">
              {firstValue?.description}
            </p>
          </div>

          <IconButton
            onClick={() => setOpenViewModal(false)}
            disableRipple
            sx={{
              '&:hover': {
                backgroundColor: 'transparent'
              }
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
        {/* Body */}
        <DialogContent
          sx={{
            padding: 0,
            height: "100%",
          }}
        >
          {selectedRow ? (
            <div className="h-full px-6 py-2">
              <DetailsPanelFile data={selectedRow} />
            </div>
          ) : (
            <div className="flex h-full items-center justify-center text-gray-500">
              No data available
            </div>
          )}
        </DialogContent>
      </Dialog>

    </div>
  );
}